/**
 * Created by Ning Jiang on 11/14/2018.
 */

export class TombstoneStrings {

    public static FS_YOU_WON_TEXT:string = "You won";
    public static FS_SPINS_PLAYED:string = "Spins played: ";
}